import React from 'react';

interface CircleDiagramProps {
    size?: number;
    progress?: number;
    thickness?: number;
    bgColor?: string;
    children?: React.ReactNode;
    progressColor?: string;
}

const CircleDiagram: React.FC<CircleDiagramProps> = ({
    size = 192,
    progress = 20,
    children,
    thickness = 10,
    bgColor = '#EEEDEC',
    progressColor = 'var(--primary-40)'
}) => {
    // Calculate necessary SVG values
    const radius = (size - thickness) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (progress / 100) * circumference;

    return (
        <div style={{ width: size, height: size, position: 'relative' }}>
            <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
                {/* Background Circle */}
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke={bgColor}
                    strokeWidth={thickness}
                />
                {/* Progress Circle */}
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke={progressColor}
                    strokeWidth={thickness}
                    strokeDasharray={circumference} // Total circumference
                    strokeDashoffset={offset} // Progress-based offset
                    strokeLinecap="round" // Rounded ends for progress arc
                    style={{ transform: 'rotate(-90deg)', transformOrigin: 'center' }} // Rotate to start from top
                />
            </svg>
            <div
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 126
                }}>
                {children}
            </div>
        </div>
    );
};

export default CircleDiagram;
